import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import Brand from 'models/brand';

import { formatPhoneNumber } from 'lib/common/format-phone-number';
import { imageCdnAsset } from 'lib/common/url-helpers';

import AppLink from 'containers/common/app-link';

import sendAppDownloadTextCreator from 'action-creators/brand/send-app-download-text';
import cleanupOurAppsPageState from 'action-creators/brand/cleanup-our-apps-page-state';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  sendAppDownloadText: PropTypes.func.isRequired,
  cleanupOurAppsPageState: PropTypes.func.isRequired,
};

const INPUT_CHANGE_TIMEOUT = 500;

export class OurAppsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: '',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onPhoneNumberFieldChange = this.onPhoneNumberFieldChange.bind(this);
  }

  componentWillUnmount() {
    this.props.cleanupOurAppsPageState();
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const { sendAppDownloadText } = this.props;
    const { phone } = this;

    sendAppDownloadText({
      phone: phone.value,
    });
  }

  onPhoneNumberFieldChange(e) {
    clearTimeout(this.phoneNumberChangeTimeout);
    const { target } = e;
    let newNumber = target.value.replace(/\D/g, '');
    const maxLength = newNumber[0] === '1' ? 11 : 10;

    // Don't let user enter more numbaZ
    newNumber = newNumber.substring(0, maxLength);
    this.setState({ phone: newNumber });
    this.phoneNumberChangeTimeout = setTimeout(this.onPhoneNumberChange, INPUT_CHANGE_TIMEOUT);
  }

  render() {
    const { phone } = this.state;
    const { brand } = this.props;

    return (
      <div>
        <div className={`our-apps-header-wrapper background-image-infini-p-main ${brand.isBestParking ? 'background-color-bp-blue' : 'background-color-watermelon'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-6 col-xs-12">
                <h1 className="h1-sg top bottom vertical-padding-top-4x vertical-padding-0-lte-sm">YOUR PARKING IS MOBILE, YOUR LIFE IS EASY.</h1>
                <h1 className="h4-sg line-height-extra vertical-padding-bottom-2x vertical-padding-0-lte-sm">From the all-in-one home screen to our virtual passes, we make booking parking a breeze.</h1>
                <div className="btn-app">
                  <AppLink
                    appStore="apple"
                    linkProps={{ c: 'apps_Page' }}
                  >
                    <img
                      className="center-block background-color-black padding-vertical-10 padding-horizontal-20 border-radius-8"
                      height="67"
                      src={imageCdnAsset('/images/app-badges/app-badge-apple-bare@2x.png')}
                      width="183"
                    />
                  </AppLink>
                </div>
                <div className="btn-app margin-left-sm-20">
                  <AppLink
                    appStore="android"
                    linkProps={{ c: 'apps_Page' }}
                  >
                    <img
                      className="center-block background-color-black padding-vertical-10 padding-horizontal-20 border-radius-8"
                      height="67"
                      src={imageCdnAsset('/images/app-badges/app-badge-android-bare@2x.png')}
                      width="183"
                    />
                  </AppLink>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 hidden-lte-sm">
                <img className="position-absolute" src={get(brand, 'appImageURLs.main', '')} alt="Parking App" />
              </div>
            </div>
          </div>
        </div>
        <div className="background-color-light-blue vertical-padding-top-2x vertical-padding-bottom-4x hidden-xs">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-6 col-xs-12 vertical-padding-bottom-4x vertical-padding-0-lte-sm">
                <h1 className="h4-sg text-color-dark-slate">Get parking in your pocket.</h1>
                <div className="input-group cta-hero-input with-phone-icon">
                  <form action="" id="appform" onSubmit={this.onSubmit}>
                    <div className="display-flex">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Enter phone number"
                        value={formatPhoneNumber(phone)}
                        onChange={this.onPhoneNumberFieldChange}
                        ref={(phoneNumber) => { this.phone = phoneNumber; }}
                      />
                      <button className="btn btn-blue focus" type="submit">SEND LINK</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


OurAppsPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  const { brand } = state.brand;
  return { brand };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    sendAppDownloadText: sendAppDownloadTextCreator,
    cleanupOurAppsPageState,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(OurAppsPage);
